import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input, OnChanges,
    OnInit,
    Output, SimpleChanges,
    ViewEncapsulation
} from '@angular/core';
import {ContextMenuAction, GenericItem} from '@emm/core/models/context-menu-action.model';
import {BehaviorSubject, Observable} from 'rxjs';
import {SharedFacadeService} from '@emm/shared/services/shared-facade.service';
import {UserService} from '@emm/core/services/user.service';
import {NotificationService} from '@emm/shared/services/notification.service';
import {map} from 'rxjs/operators';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-generic-items-list',
    styleUrls: ['./generic-items-list.component.scss'],
    templateUrl: './generic-items-list.component.html',
    standalone: false
})
export class GenericItemsListComponent implements OnInit {
    items$ = new BehaviorSubject<GenericItem<any>[]>([]);

    @Input() contextMenuActions: ContextMenuAction<any>[];
    @Input() disableContextActions: boolean;
    @Input()
    set items(value: GenericItem<any>[]) {
        this.items$.next(value);
    }
    @Input() isReadOnly: boolean;
    @Input() selectedItem: GenericItem<any>;
    @Input() changeOnSelect = true;
    @Input() isMmsAuthorOnly = false;

    @Output() onSelectItem = new EventEmitter<any>();

    showTags$: Observable<boolean>;

    constructor(
        private sharedFacadeService: SharedFacadeService,
        private notificationService: NotificationService,
        private userService: UserService,
     ) {}

    ngOnInit(): void {
        this.showTags$ = this.sharedFacadeService.showTags$.pipe(
            map(showTags => showTags === 'true')
        );
    }

    onItemSelected(item: any) {
        if (this.isMmsAuthorOnly) {
            return this.notificationService.error('MMS Authors do not have this permission');
        }
        this.onSelectItem.emit(item);
        if (this.changeOnSelect) {
            this.selectedItem = item;
        }
    }
}
